import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserManagementComponent } from 'src/app/common/user/components/user-management/user-management.component';
import { GenericConfirmationDialogComponent, ConfirmDialogModel } from '../../generic-confirmation-dialog/generic-confirmation-dialog.component';

@Component({
  selector: 'app-user-management-dialog',
  templateUrl: './user-management-dialog.component.html',
  styleUrls: ['./user-management-dialog.component.scss']
})
export class UserManagementDialogComponent implements OnInit {

  @ViewChild(UserManagementComponent) userManagement: UserManagementComponent;

  constructor(
    public dialogRef: MatDialogRef<UserManagementDialogComponent>,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  onDoneClicked(): void {
    // Check if the child has unsaved edits 
    if (this.userManagement?.hasUnsavedEdit) {

      const message = "There is an unsaved change to a user's permission group. Would you like to save it before exiting?"
      const dialogRefConfirm = this.dialog.open(GenericConfirmationDialogComponent, 
        {
          width: '400px',
          disableClose: true
        });

      let instance = dialogRefConfirm.componentInstance;
      instance.dialogRef = dialogRefConfirm;
      instance.title = "Unsaved Change";
      instance.message = message;

      dialogRefConfirm.afterClosed().subscribe((userConfirmed) => {
        if (userConfirmed === true) {
          // “Yes” => Save changes
          if (this.userManagement.isOrgLevel) {
            // If org-level, call changeUserDetails()
            this.userManagement.changeUserDetails();
          } else {
            // Otherwise, call changeRole()
            this.userManagement.changeRole();
          }
          this.dialogRef.close();
        } else {
          // “No” => Discard changes
          this.userManagement.editUserFormGroup.reset();
          this.userManagement.editingUser = null;
          this.dialogRef.close();
        }
      });
    } else {
      // If there are no unsaved edits, close immediately
      this.dialogRef.close();
    }
  }

}
